import type { SidebarMenu } from '../types';

/**
 * 역할에 따라 매니저 사이드바 메뉴를 필터링합니다.
 * 메뉴 노출은 탐색 편의용이며, 권한이 필요한 화면은 해당 route의 guard를 별도로 유지합니다.
 */
export function filterManagerMenusByRoles(menus: SidebarMenu[], roles: string[]): SidebarMenu[] {
  return menus.filter(menu => {
    return menu.roles?.some(role => roles.includes(role)) ?? false;
  });
}
